import React from 'react';
import FeedbackFormOverlay from './FeedbackFormOverlay';
import TransmitFormOverlay from '../AlmeOverlayForm/transmit/TransmitFormOverlay';
import { getTranmitStartWorkflowResp, overlayDataCollectionResponse } from './DisplayFormResponseAction';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
const OverlayForm = (props) => {
    const overlayDataCollectionResp = overlayDataCollectionResponse(props.response.responseActions);
    const transmitStartWorkflowResp = getTranmitStartWorkflowResp(props.response.responseActions);
    return (React.createElement(ErrorBoundary, { appConfig: props.appConfig },
        React.createElement(React.Fragment, null,
            overlayDataCollectionResp && props.isLastResponse ? (React.createElement(FeedbackFormOverlay, { responseAction: overlayDataCollectionResp, onFeedbackFormSubmit: props.onSubmitFormAppEvent })) : null,
            transmitStartWorkflowResp && props.isLastResponse
                ? (React.createElement(TransmitFormOverlay, { appConfig: props.appConfig, responseAction: transmitStartWorkflowResp, onTransmitAuthComplete: props.onSubmitFormAppEvent }))
                : null)));
};
export default OverlayForm;
